export const primaryTheme = {
}

export type Theme = typeof primaryTheme;
